import type { JSX } from "react";

import { Dialog as BaseDialog } from "@base-ui/react/dialog";
import { useIslandPortalContainer } from "@frontend/contexts";

import type { DialogPortalProps } from "./Dialog.types";

export function DialogPortal({
  children,
  ...props
}: DialogPortalProps): JSX.Element {
  // Dialog's content can project a caller-supplied `<slot>` (see
  // Dialog.rwc.tsx) — it must stay in the same shadow tree as that `<slot>`,
  // i.e. its own island's shadow root, not the shared floating-popup root
  // used by Select/Menu/Tooltip/Combobox.
  const container = useIslandPortalContainer();

  return (
    <BaseDialog.Portal
      data-slot="dialog-portal"
      container={container}
      {...props}
    >
      {children}
    </BaseDialog.Portal>
  );
}
